import React, { useState, useEffect } from "react";
import styles from "./page4.module.scss";
import key from "../../icons/key.svg";
import bulb from "../../icons/bulb.svg";
import lock from "../../icons/lock.svg";
import tick from "../../icons/ppimage.svg";
import animated from "../../images/animated.svg";
import videoanimation from "../../images/autoscrollVideo.mp4";

export default function Page4() {
  const [dotPosition, setDotPosition] = useState("114px");

  const handleClickCircle1 = () => {
    setDotPosition("114px");
  };
  const handleClickCircle2 = () => {
    setDotPosition("204px");
  };
  const handleClickCircle3 = () => {
    setDotPosition("293px");
  };
  const handleClickCircle4 = () => {
    setDotPosition("383px");
  };

  const data = [
    {
      icon: tick,
      title: "Unparalleled Integration Ease",
      subText:
        " With a developer-friendly setup process, integrating Firstock Connect takes minutes, not days.",
      background: "rgba(187, 212, 239, 1)",
      iconBg: "rgba(83, 156, 233, 1)",
      position: "114px",
    },
    {
      icon: key,
      title: "Real-time Data Accuracy",
      subText:
        "Our API ensures you get real-time trading data without lags or delays, ensuring every trade decision is informed and timely.",
      background: "rgba(182, 223, 236, 1)",
      iconBg: "rgba(49, 190, 235, 1)",
      position: "204px",
    },
    {
      icon: bulb,
      title: "Scalable Solutions",
      subText:
        "Whether you're a startup or an enterprise, our API scales with your needs, ensuring smooth operations irrespective of the trading volume.",
      background: "rgba(204, 231, 190, 1)",
      iconBg: "rgba(111, 174, 78, 1)",
      position: "293px",
    },
    {
      icon: lock,
      title: "Secure and Reliable Operations",
      subText:
        "Firstcok Connect prioritizes your data's security. With top-notch encryption and security protocols, your trades and data remain confidential.",
      background: " rgba(244, 181, 136, 1)",
      iconBg: "rgba(255, 146, 67, 1)",
      position: "383px",
    },
  ];

  const changeStepperAutomatically = () => {
    const positions = ["114px", "204px", "293px", "383px"];
    let currentIndex = positions.indexOf(dotPosition);
    if (currentIndex === -1) {
      currentIndex = 0;
    } else {
      currentIndex = (currentIndex + 1) % positions.length;
    }
    if (window.pageYOffset > 1500) {
      setDotPosition(positions[currentIndex]);
    } else {
      setDotPosition("114px");
    }
  };

  useEffect(() => {
    const intervalId = setInterval(changeStepperAutomatically, 2500);

    return () => clearInterval(intervalId);
  }, [dotPosition]);

  return (
    <div className={styles.mainwrapperfourpage}>
      <div className={styles.top}>
        <p className={styles.toppara}>
          Here’s why prefer{" "}
          <span style={{ color: "#6D00FF" }}>Firstock Connect</span> for
          comprehensive trading platform.
        </p>
      </div>
      <div className={styles.bottom}>
        {data.map((a: any, index: any) => (
          <div
            className={styles.left}
            // style={{
            //   background: a.background,
            //   display: dotPosition === a.position ? "block" : "none",
            //   transition: "display 2s ease",
            // }}
            style={{
              background: a.background,
              display: dotPosition === a.position ? "block" : "none",
              opacity: dotPosition === a.position ? 1 : 0,
              transition: "opacity 0s ease",
            }}
          >
            <div>
              <div
                className={styles.imagecontainer}
                style={{ background: a.iconBg }}
              >
                <img className={styles.firstimage} src={a.icon} alt="key" />
              </div>
              <p className={styles.heading}>{a.title}</p>
              <p className={styles.para}>{a.subText}</p>
            </div>
          </div>
        ))}

        <div className={styles.stepper}>
          <div className={styles.stepperLineTop}></div>
          <div
            className={styles.stepperdot}
            style={{ position: "absolute", top: dotPosition }}
          ></div>
          <div
            className={styles.stepperCircle1}
            onClick={() => {
              handleClickCircle1();
            }}
          ></div>
          <div
            className={styles.stepperLineBetween}
            style={{
              background: dotPosition == "204px" ? "rgba(67, 159, 255, 1)" : "",
              transition: "0.9s ease",
            }}
          ></div>
          <div
            className={styles.stepperCircle2}
            onClick={() => {
              handleClickCircle2();
            }}
          ></div>
          <div
            className={styles.stepperLineBetween}
            style={{
              background:
                dotPosition == "293px" ? "rgba(182, 223, 236, 1)" : "",
              transition: "0.9s ease",
            }}
          ></div>
          <div
            className={styles.stepperCircle3}
            onClick={() => {
              handleClickCircle3();
            }}
          ></div>
          <div
            className={styles.stepperLineBetween}
            style={{
              background:
                dotPosition == "383px" ? "rgba(204, 231, 190, 1)" : "",
              transition: "0.9s ease",
            }}
          ></div>
          <div
            className={styles.stepperCircle4}
            onClick={() => {
              handleClickCircle4();
            }}
          ></div>
          <div className={styles.stepperLineTop}></div>
        </div>
        <div className={styles.right}>
          {/* <img
            className={styles.animationgifimage}
            src={animated}
            alt="animated"
          /> */}
          <video
            autoPlay={true}
            loop
            muted
            className={styles.animationgifimage}
          >
            <source
              src="https://firstock-common.s3.ap-south-1.amazonaws.com/projects/connect/landingpage2.mp4"
              type="video/mp4"
            />
          </video>
        </div>
      </div>
    </div>
  );
}
